// SalesTableFlatCASH.js
import React, {useRef} from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableFooter, CircularProgress, Typography ,Box} from "@mui/material";

// Define the exact column structure
const SALESLIST_CASH_COLUMNS = [
    { header: 'DEPT NO', key: 'DEPTNO', numeric: false },
    { header: 'INV NO', key: 'INVNO', numeric: false },
    { header: 'INV DATE', key: 'INV_DATE', numeric: false },
    { header: 'CUSTOMER', key: 'CUSTOMER', numeric: false },
    { header: 'SO NO', key: 'SO_NO', numeric: false },
    { header: 'LPO', key: 'LPO', numeric: false },
    { header: 'SALES MAN', key: 'SALES MAN', numeric: false, isLabel: true }, // Cell for the "GRAND TOTAL:" label
    { header: 'AMOUNT', key: 'AMOUNT', numeric: true },
    { header: 'CASHCRED', key: 'CASHCRED', numeric: false },
    { header: 'ACCOUNT', key: 'ACCOUNT', numeric: false },
    { header: 'VAT AMT', key: 'VATAMT', numeric: true },
    { header: 'COMMISSION', key: 'COMMISSION', numeric: true },
    { header: 'AMOUNT EXCLVAT', key: 'AMOUNT_EXCLVAT', numeric: true },
    { header: 'TYPE', key: 'TYPE', numeric: false },
];
const TOTAL_COLUMNS = 14;

// Assuming formatNumber helper is passed down or available
const formatNumber = (val) => Number(val || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const SalesTableFlatCASH = ({ rows, grandColumnTotals, loading,loadNextPage, hasMore }) => {



    const tableContainerRef = useRef(null);

    // 🚨 2. Define the scroll detection logic
    const handleTableScroll = () => {

        console.log("scrolled-->")
        const currentTarget = tableContainerRef.current;

        if (!currentTarget || loading || !hasMore || rows.length === 0) return;

        const { scrollTop, scrollHeight, clientHeight } = currentTarget;

        // Load the next page when reaching the bottom (with a 10px buffer)
        if (scrollHeight - scrollTop <= clientHeight + 10) {
            loadNextPage();
        }
    };


    const renderBody = () => (
        <TableBody>
            {rows.map((row, index) => (
                <TableRow key={`row-cash-${index}`} sx={{ backgroundColor: '#fff', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                    {SALESLIST_CASH_COLUMNS.map(col => {
                        const cellValue = row[col.key] || row[col.key.replace(/_/g, '')] || row[col.key.replace(/([A-Z])/g, ' $1').trim()];

                        return (
                            <TableCell
                                key={col.key}
                                align={col.numeric ? "right" : "left"}
                                sx={col.key === 'AMOUNT' ? { fontWeight: 'bold' } : {}}
                            >
                                {col.numeric ? formatNumber(cellValue) : (col.key === 'INV_DATE' ? cellValue?.split('T')[0] : cellValue)}
                            </TableCell>
                        );
                    })}
                </TableRow>
            ))}

             {/* Load More Indicator */}
             {hasMore && (
                            <Box sx={{ textAlign: 'center', py: 2 }}>
                                <CircularProgress size={24} />
                                <Typography variant="caption" display="block">
                                    Loading more data...
                                </Typography>
                            </Box>
                        )}

            {!loading && rows.length === 0 && (
                <TableRow><TableCell colSpan={TOTAL_COLUMNS} align="center"><Typography variant="subtitle1" color="textSecondary">No sales data found for the selected filters.</Typography></TableCell></TableRow>
            )}
        </TableBody>
    );

    const renderFooter = () => (
        <TableFooter>
            <TableRow sx={{ backgroundColor: '#b3b3b3', borderTop: '3px double #000' }}>
                {SALESLIST_CASH_COLUMNS.map(col => {
                    const isNumericTotal = col.numeric;
                    const isLabelCell = col.isLabel;

                    let content = isNumericTotal ? formatNumber(grandColumnTotals[col.key] || 0) : (isLabelCell ? 'GRAND TOTAL:' : '');
                    let align = isNumericTotal || isLabelCell ? 'right' : 'left';
                    let cellStyle = isNumericTotal ? { fontWeight: 'bold', color: '#000000', fontSize:20 } : { fontWeight: 'bold',color: '#000000', fontSize:20 };

                    return (
                        <TableCell
                            key={col.key}
                            align={align}
                            sx={{
                                ...cellStyle,
                                position: 'sticky',
                                bottom: 0,
                                zIndex: 10,
                                backgroundColor: '#b3b3b3',
                                padding: '8px 16px',
                                whiteSpace:"nowrap"
                            }}
                        >
                            {content}
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableFooter>
    );

    return (
        <TableContainer
            ref={tableContainerRef}
            onScroll={handleTableScroll} // ⬅️ ATTACH SCROLL HANDLER HERE
            sx={{
                maxHeight: 'calc(100vh - 350px)',
                overflowY: 'auto', width: '100%'
            }}>
            <Table stickyHeader aria-label="sales analysis cash report">
                <TableHead>
                    <TableRow>
                        {SALESLIST_CASH_COLUMNS.map(col => (
                            <TableCell key={col.key} align={col.numeric ? "right" : "left"} style={{ minWidth: 120, whiteSpace: 'nowrap' }}>
                                {col.header}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                {renderBody()}
                {Object.keys(grandColumnTotals).length > 0 && renderFooter()}
            </Table>

            {loading && (
                <div style={{ display: "flex", justifyContent: 'center', alignItems: "center", width: "100%", height: "100%", position: "absolute", zIndex: 100, backgroundColor: "#ffffff80", top: "0px", left: "0px" }}>
                    <CircularProgress size={48} />
                </div>
            )}

        </TableContainer>
    );
};

export default SalesTableFlatCASH;